// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

/* eslint-disable */
import { ref, onMounted } from '@vue/composition-api'
import store from '@/store'
import AppConstants from '@/appConstants'
// import dropdownService from '@/providers/dropdownService'
import messagesNotifyHelper from '@/helpers/messages-notify-helper'


export default function useImageLibRegister() {
    // ------------------------------------------------
    // DATA
    // ------------------------------------------------
    const form = ref({
        _id: '',
        filename: '',
        image_path: '',
        copyright: '',
        active: true,
        tags: [],
        // origins: [],
        // subjects: [],
        dt_create: '',
        email_create: '',
        dt_update: '',
        email_update: '',
        file: null,
    });

    let files = ref([]);
    let compressPdf = ref(false);
    let image_type = ref(AppConstants.FILE_TYPE);
    // const origins = ref([]);
    // const subjects = ref([]);
    // const originModel = ref(null);

    // Use toast
    const toast = useToast()

    onMounted(() => { })

    // const selectedRegion = computed(() => store.state.calendar.selectedRegion)
    // --------------------------------------------------------------------------------------------------
    // COMPUTED
    // --------------------------------------------------------------------------------------------------

    // watch(originModel, (val) => {
    //     if (val.length > 0) {
    //         form.value.origins = val;
    //         loadSubjectsByOrigin(val.slice());
    //     } else {
    //         subjects.value = [];
    //         form.subjects.value = [];
    //     }
    // })

    // ------------------------------------------------
    // ORIGINS
    // ------------------------------------------------
    // const loadOrigins = () => {
    //     dropdownService.getAllOrigin(new URLSearchParams())
    //         .then(resp => {
    //             origins.value = resp;
    //         })
    //         .catch(err => console.log(err));
    // }
    // const loadSubjectsByOrigin = (currentOrigins) => {
    //     subjects.value = [];
    //     const params = new URLSearchParams();
    //     params.append('origins', currentOrigins.map((item) => item.id));
    //     dropdownService.getAllSubjects(params)
    //         .then(resp => {
    //             subjects.value = resp;
    //         })
    //         .catch(err => console.log(err));
    // }
    // loadOrigins();

    // --------------------------------------------------------------------------------------------------
    // FUNCTIONS
    // --------------------------------------------------------------------------------------------------
    const fetchDetail = (self) => {
        if (self.$route.params.id) {
            form.value._id = self.$route.params.id;
        } else {
            return;
        }
        // Fetch Events from API endpoint
        const params = new URLSearchParams();
        store
            .dispatch(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/fetchImageDetail`, {
                id: form.value._id,
                params: params
            })
            .then(response => {
                form.value._id = response._id;
                form.value.copyright = response.copyright;
                form.value.tags = response.tags;
                form.value.filename = response.image_filename;
                form.value.image_path = response.image_path;
                form.value.dt_create = response.dt_create;
                form.value.email_create = response.email_create;
                form.value.dt_update = response.dt_update;
                form.value.email_update = response.email_update;
                form.value.active = response.active;

                // form.value.subjects = response.subjects;
                // originModel.value = response.origins;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching calendar events',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resetForm = () => {
        form.value._id = '';
        form.value.filename = '';
        form.value.image_path = '';
        form.value.copyright = '';
        form.value.active = true;
        form.value.tags = [];
        form.value.dt_create = '';
        form.value.email_create = '';
        form.value.dt_update = '';
        form.value.email_update = '';
        form.value.file = null;
        compressPdf.value = false;
        files.value = [];
    }

    const onSubmit = (self) => {
        // Fetch Events from API endpoint
        const formData = new FormData();
        for (let index = 0; index < files.value.length; index++) {
            const extension = files.value[index].file.name.substring(files.value[index].file.name.indexOf('.') + 1);
            if (AppConstants.MEDIA_DOCUMENT_EXTENSIONS.indexOf(extension) >= 0) {
                formData.append(`documents[${index}]`, files.value[index].file);
            } else {
                formData.append(`images[${index}]`, files.value[index].file);
            }
        }
        formData.append("_id", form.value._id);
        formData.append("copyright", form.value.copyright);
        formData.append("active", form.value.active);
        formData.append("compressPdf", compressPdf.value);
        if (form.value.tags.length > 0) {
            for (let index = 0; index < form.value.tags.length; index++) {
                formData.append(`tags[${index}]`, form.value.tags[index]);
            }
        }
        store
            .dispatch(`${AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME}/register`, {
                form: formData,
                params: new URLSearchParams()
            })
            .then(response => {
                console.log(response);
                if (form.value._id) {
                    messagesNotifyHelper.updatedRecordNotify();
                } else {
                    messagesNotifyHelper.createdRecordNotify();
                    resetForm();
                    onBackPage(self);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const onBackPage = (self) => {
        self.$emit('back');
    }

    // ------------------------------------------------------------------------

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    return {
        form,
        compressPdf,
        files,
        image_type,
        // origins,
        // subjects,
        // originModel,
        // ----- Functions ----- //
        onSubmit,
        fetchDetail,
        // loadSubjectsByOrigin,
        onBackPage,
    }
}
